import {
  getTmtFaceHours,
  getTmtFaceMin,
  getTmtSupplementalHours,
  getTmtSupplementalMin,
} from './verificationUtils';

export const _setVerPrtId = (state, action) => {
  state.VerificationDialogPopup.verPrtId = action.payload;
};

export const _setIsDropDownCall = (state, action) => {
  state.VerificationDialogPopup.isDropDownCall = action.payload;
};

export const _setIsTmtStsId = (state, action) => {
  state.VerificationDialogPopup.isTmtStsId = action.payload;
};

export const _setCheckAdm = (state, action) => {
  state.VerificationDialogPopup.checkAdmValue = action.payload;
};

export const _setIntMedValueId = (state, action) => {
  state.VerificationDialogPopup.intMedValue = action.payload;
};

export const _setIntMedId = (state, action) => {
  state.VerificationDialogPopup.intMedId = action.payload;
};

export const _setIsStatusTag = (state, action) => {
  state.VerificationDialogPopup.isStatusTag = action.payload;
};

export const _setIsCallVerifyPopup = (state, action) => {
  state.VerificationDialogPopup.isCallVerifyPopup = action.payload;
};

export const _setIsValidateP3 = (state, action) => {
  state.VerificationDialogPopup.isValidateP3Call = action.payload;
};

export const _setVerIcnCDC = (state, action) => {
  state.VerificationDialogPopup.verIcnCDC = action.payload;
};

export const _setVerEpdId = (state, action) => {
  state.VerificationDialogPopup.verEpdId = action.payload;
};

export const _setVerSapAthId = (state, action) => {
  state.VerificationDialogPopup.verSapAthId = action.payload;
};

export const _setVerSapAthMaxUnits = (state, action) => {
  state.VerificationDialogPopup.verSapAthMaxUnits = action.payload;
};

export const _setVerSapAthMaxWkUnits = (state, action) => {
  state.VerificationDialogPopup.verSapAthMaxWkUnits = action.payload;
};

export const _setI1TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i1TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI2TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i2TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI3TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i3TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI4TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i4TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI5TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i5TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI6TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i6TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setI7TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.i7TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG1TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g1TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG2TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g2TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG3TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g3TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG4TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g4TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG5TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g5TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG6TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g6TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setG7TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.g7TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD1TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d1TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD2TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d2TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD3TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d3TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD4TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d4TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD5TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d5TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD6TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d6TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setD7TmtTmtStsId = (state, action) => {
  state.VerificationDialogPopup.d7TmtTmtStsId = action.payload;
  state.VerificationDialogPopup.isCallApi = true;
  state.VerificationDialogPopup.isValidateP3Call = true;
};

export const _setFaceTimei1 = (state, action) => {
  state.VerificationDialogPopup.faceTimei1 = action.payload;
  state.VerificationDialogPopup.i1TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i1TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei2 = (state, action) => {
  state.VerificationDialogPopup.faceTimei2 = action.payload;
  state.VerificationDialogPopup.i2TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i2TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei3 = (state, action) => {
  state.VerificationDialogPopup.faceTimei3 = action.payload;
  state.VerificationDialogPopup.i3TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i3TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei4 = (state, action) => {
  state.VerificationDialogPopup.faceTimei4 = action.payload;
  state.VerificationDialogPopup.i4TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i4TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei5 = (state, action) => {
  state.VerificationDialogPopup.faceTimei5 = action.payload;
  state.VerificationDialogPopup.i5TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i5TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei6 = (state, action) => {
  state.VerificationDialogPopup.faceTimei6 = action.payload;
  state.VerificationDialogPopup.i6TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i6TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setFaceTimei7 = (state, action) => {
  state.VerificationDialogPopup.faceTimei7 = action.payload;
  state.VerificationDialogPopup.i7TmtFaceHours = getTmtFaceHours(
    action.payload
  );
  state.VerificationDialogPopup.i7TmtFaceMins = getTmtFaceMin(action.payload);
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei1 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei1 = action.payload;
  state.VerificationDialogPopup.i1TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i1TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei2 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei2 = action.payload;
  state.VerificationDialogPopup.i2TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i2TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei3 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei3 = action.payload;
  state.VerificationDialogPopup.i3TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i3TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei4 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei4 = action.payload;
  state.VerificationDialogPopup.i4TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i4TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei5 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei5 = action.payload;
  state.VerificationDialogPopup.i5TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i5TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei6 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei6 = action.payload;
  state.VerificationDialogPopup.i6TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i6TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};

export const _setSupplementalTimei7 = (state, action) => {
  state.VerificationDialogPopup.supplementalTimei7 = action.payload;
  state.VerificationDialogPopup.i7TmtSuppHours = getTmtSupplementalHours(
    action.payload
  );
  state.VerificationDialogPopup.i7TmtSuppMins = getTmtSupplementalMin(
    action.payload
  );
  state.VerificationDialogPopup.isCallApi = true;
};
